import { render, staticRenderFns } from "./AutocompleteSpecialite.vue?vue&type=template&id=22b14216&scoped=true&"
import script from "./AutocompleteSpecialite.vue?vue&type=script&lang=js&"
export * from "./AutocompleteSpecialite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b14216",
  null
  
)

export default component.exports